import styled from "@emotion/styled";

import {
  colors,
  flexCentering,
  Link,
  VStack,
  HStack,
  ColorIcon,
} from "goi_common";

import { css } from "@emotion/react";

interface BigParlorProps {
  href: string;
  src?: string | null;
  name: string;
  address: string;
  price: number;
  managed_type: "대학병원" | "공설" | "전문";
}

export const BigParlor = ({
  href,
  src,
  name,
  address,
  price,
  managed_type,
}: BigParlorProps) => {
  return (
    <BigParlorRoot href={href}>
      <VStack
        as="figure"
        borderRadius={5}
        overflow="hidden"
        boxShadow="0 0 7px rgba(113, 120, 125, 0.2)"
      >
        <ParlorImage src={src}>
          <Type className="subtitle3 warmGray400">{managed_type}</Type>
          {!src && <ColorIcon name="logo" color="white" size={40} />}
        </ParlorImage>
        <VStack
          as="figcaption"
          gap={5}
          padding="12px 16px 22px"
          background={colors.white}
        >
          <div className="subtitle2_b gray600 font-ellipsis">{name}</div>
          <HStack alignItems="center">
            <div className="body3_r gray600">{address}</div>
          </HStack>
          {price > 0 && (
            <div className="body3_r gray500">
              빈소 평균 {price.toLocaleString()}원
            </div>
          )}
        </VStack>
      </VStack>
    </BigParlorRoot>
  );
};

const BigParlorRoot = styled(Link)`
  width: 100%;

  @media (min-width: 640px) {
    width: calc(50% - 10px);
  }
`;

const ParlorImage = styled.div<{ src?: string | null }>`
  ${flexCentering("row")};
  ${(props) => backgroundBySrc(props.src)};

  position: relative;
  aspect-ratio: 320 / 180;
  background-size: cover;
  background-position: center;
`;

const Type = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px 10px;
  background: var(--gray900);
`;

const backgroundBySrc = (src?: string | null) => {
  if (src)
    return css`
      background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 41.15%,
          rgba(37, 37, 37, 0.95) 100%
        ),
        url("${src}");
    `;
  return css`
    background: linear-gradient(
        180deg,
        rgba(185, 185, 185, 0) 49.48%,
        rgba(37, 37, 37, 0.95) 100%
      ),
      var(--gray100);
  `;
};
